import { render, staticRenderFns } from "./wf-overridable-select-display.vue?vue&type=template&id=2ff68890&scoped=true&"
import script from "./wf-overridable-select-display.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-select-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-select-display.vue?vue&type=style&index=0&id=2ff68890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff68890",
  null
  
)

export default component.exports